import CustomForm from "../CustomForm";
import m, {Vnode} from "mithril";

export default abstract class SeznamMapCustomForm extends CustomForm {

    /**
     * Define API_KEY
     *  - development key is free public api_key with only small amount of credits per month
     *  - production key is paid (higher limits) but it is restricted for our survey domains by referrer, but not localhost
     */
    public static readonly API_KEY = process.env.NODE_ENV === 'development' ? 'OYYtSyedDSQjdP35exqWZjJrss4CK2DqYcyvyv4i8CU' : 'hrRv9xqgube4i9hF7-L9Lo_D7lU3Wc3RtWVzYo1mUrc';

    public static getTilesUrl(): string {
        const tileSize = window.devicePixelRatio > 1.3 ? '256@2x' : '256';
        return `https://api.mapy.cz/v1/maptiles/basic/${tileSize}/{z}/{x}/{y}?apikey=${SeznamMapCustomForm.API_KEY}`;
    }

    public rewriteFormControls(): boolean {
        return true;
    }

    protected viewLoading(): Vnode {
        const messages = this.settings.form.questionary.messages;
        return m('.loading', {}, [
            m('.loader', {}, [
                m('.loader-spinner'),
                m('.loader-message', {}, m.trust(messages.get('loading'))),
            ])
        ]);
    }
}
